import React, { useState } from 'react';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { useParams } from 'react-router-dom';
import { ApplicantView } from 'app/edozvola/cases/case-applicant/model/case-applicant.model';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { deleteApplicantQuery, fetchApplicantsQuery } from 'app/edozvola/cases/case-applicant/service/case-applicant.queries';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { findAssigneeNamesLinkedToSelectedApplicant } from 'app/edozvola/cases/case-applicant/service/case-applicant.service';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const CaseApplicantTable = ({ setApplicant, setReadOnly, setSystemRecorded }) => {
  const { id } = useParams<{ id: string }>();
  const [idApplicantToDelete, setIdApplicantToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();
  const initialText = 'Jeste li sigurni da želite obrisati podatke?';
  const [deleteModalText, setDeleteModalText] = useState(initialText);

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.APPLICANTS_TABLE);

  const { mutate: deleteApplicantMutation, isPending: applicantDeletionPending } = deleteApplicantQuery();

  const openDeleteDialog = async applicant => {
    setIdApplicantToDelete(applicant.idApplicant);

    if (applicant.hasAssigneeLinkedOnlyToThisApplicant) {
      const names = await findAssigneeNamesLinkedToSelectedApplicant(applicant.idApplicant);
      setDeleteModalText(
        `Brisanjem podnositelja obrisat će se i njegov opunomoćenik: ${names}. Jeste li sigurni da želite obrisati podatke?`,
      );
    } else {
      setDeleteModalText(initialText);
    }

    setDeleteModalShown(true);
  };

  const removeApplicant = () => {
    setDeleteModalShown(false);
    setDeleteModalText(initialText);
    deleteApplicantMutation(idApplicantToDelete);
  };

  const openApplicantForm = (idApplicant: number, readOnly: boolean, systemRecorded: boolean) => {
    setApplicant(idApplicant);
    setReadOnly(readOnly);
    setSystemRecorded(systemRecorded);
  };

  const renderTableRow = (value: ApplicantView, applicantIndex: number, totalItems: number) => {
    return (
      <tr key={applicantIndex} className={invalidRowIds.includes(value.idApplicant) ? 'invalid-table-row' : ''}>
        <td>{value.name}</td>
        <td>{value.oibMb}</td>
        <td>{value.partyType}</td>
        <td>{value.address}</td>
        <td>{value.email}</td>

        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon
                  icon={'eye'}
                  className={'icon-table'}
                  onClick={() => openApplicantForm(value.idApplicant, true, value.systemRecorded)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openApplicantForm(value.idApplicant, false, value.systemRecorded)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && !value.systemRecorded && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema podnositelja'}
        initialPaginationColumn={'idApplicant'}
        fetchDataQuery={fetchApplicantsQuery}
        fetchDataProps={[id]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Ime i prezime/Naziv']} width={'15%'}  />
        <ViewTableHeaderColumn renderSort sortKey={'oibMb'} columnLabels={['OIB/MB']} width={'5%'}  />
        <ViewTableHeaderColumn renderSort sortKey={'partyType'} columnLabels={['Vrsta stranke']} width={'10%'}  />
        <ViewTableHeaderColumn renderSort sortKey={'address'} columnLabels={['Adresa']} width={'15%'} />
        <ViewTableHeaderColumn renderSort sortKey={'email'} columnLabels={['Email']} width={'10%'}  />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'3%'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje podnositelja/opunomoćenika</span>
        </ModalHeader>
        <ModalBody>
          <div>{deleteModalText}</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeApplicant} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CaseApplicantTable;
